import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function SAMPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Materials and Methods</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Study Area: The Western Ghats (Sahyadri), extending from 8&deg; N
              to 21&deg; N latitudes and 73&deg; E to 77&deg; E longitudes
              (Figure 1), is one among 36 global biodiversity hotspots (Myers et
              al. 2000), one among the eight unique &lsquo;hottest
              hotspots&rsquo; of biological diversity, and also one of the
              primaries of the 200 globally most important ecoregions (Olson et
              al. 2001). It is a continuous escarpment spreading from Gujarat to
              Kerala states covering an area of 160000 km<sup>2</sup>
              (constitutes only 5% of India&rsquo;s geographical extent) and a
              length of 1600 km with an exceptionally small break in the far
              south called &lsquo;Palghat gap&rsquo; between Nilgiri hills and
              Annamalai ranges. It is one of the oldest mountain chains,
              retaining the original Gondwanaland geology. It has elevation
              ranges from 300-2700 meters, spread across six states (i.e.,
              Gujarat, Maharashtra, Goa, Karnataka, Tamil Nadu, Kerala) and a
              union territory (Dadra and Nagar Haveli) of India, with a mean
              annual rainfall of 2500mm. The forest landscape, due to
              variability in precipitation and topographic diversity, comprises
              a wide variety of eco-zones ranging from wet evergreen and
              semi-evergreen forests at high altitudes, moist deciduous forests
              in the medium altitudes, and dry deciduous forests, scrub type on
              the eastern slopes and lowlands (Champion and Seth 1968). The
              Western Ghats are endowed with perennial river networks and
              function as a water tower for peninsular India, ensuring water and
              food security, and sustaining the livelihood of millions of
              dependent populations.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/wgb1.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Figure 1. Study region - the Western Ghats of India
            </p>
            <p>
              Forest ecosystems support various lifeforms, providing goods and
              services and acting as a lifeline for the dependent population.
              The diverse agriculture and horticulture sectors are being
              supported by perennial water flows across the region. The presence
              of patch forests with relics highlights the lineage of primeval
              forests. Large-scale anthropogenic activities across the Western
              Ghats have accentuated land degradation leading to deforestation.
              The presence of close canopies, magnificent trees, large herds of
              elephant movements, troops of lion-tailed macaques in southern
              rain forests, and herds of jumping deer across the various forest
              types highlight the scope for conservation through sustainable
              management approaches to maintain the ecological integrity of the
              serene landscape.
            </p>
            <p>&nbsp;</p>
            <h5>Method</h5>
            <p>
              Identification and delineation of ESRs in the Westerns Ghats have
              been carried out as outlined in Figure 2.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/wgb2.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              Figure 2. The protocol employed for the delineation of ESR regions
              at disaggregated levels
            </p>
            <h5>Quantification of spatiotemporal changes in LU</h5>
            <p>
              Temporal remote sensing (RS) data from 1985 to 2020 has been
              analysed with the help of field data, and collateral data such as
              vegetation maps of the French institute Puducherry (Pascal 1986),
              topographic maps from the Survey of India
              (https://onlinemaps.surveyofindia.gov.in/Home.aspx), biodiversity
              information from the biodiversity
              portal(http://indiabiodiversity.org/), and LU attribute
              information from the virtual spatial data portals such as Google
              Earth (http://earth.google.com), Bhuvan
              (http://bhuvan.nrsc.gov.in). RS data of 1985 (100m resolution
              resampled to 30m) is procured from International
              Geosphere-Biosphere Programme (IGBP), and Landsat 8 OLI
              (Operational Land Imager &ndash; 30m) for 2020 was pre-processed
              for geometric (geo-referencing) and radiometric corrections. Field
              surveys across forest types have been carried out to collect
              training data for LU analysis and attribute data pertaining to
              species composition. Remote sensing data has been classified
              through the supervised classifier based on the Gaussian maximum
              likelihood algorithm (Otukei and Blaschke 2010; Ramachandra et al.
              2019a). Land use classification using remote sensing data involved
              (i) the creation of False Colour Composite(FCC) to identify
              heterogeneous features; (ii) the selection of training sites by
              integrating secondary data with field data (60%), covering at
              least 15% of the scene area and training polygons uniformly
              distributed across the study region;(iii) LU analysis through
              supervised classification technique to differentiate eight
              distinct LU categories using GRASS GIS (Geographical Analysis
              Support System); (iv) accuracy assessment to validate the
              classification based on rest (40%) of field samples(Lillesand et
              al. 2014). LU analysis has aided in evaluating the condition of
              forests through fragmentation matrices, as per equations 1, and 2
              (Riitters et al. 2002; Ku&egrave;as et al. 2011; Ramachandra et
              al. 2016b). Indices P<sub>f </sub>and P<sub>ff</sub> were computed
              through a moving kernel/window of 5&times;5 pixels over the study
              area map. The analysis has categorized forests into five distinct
              fragmentation groups (Ramachandra et al. 2016b). Lakes, streams,
              or river courses were excluded, which aid as a natural corridor of
              non-fragmenting features. At the same time, anthropogenic
              landscape elements (such as paved surfaces-buildings, roads;
              agricultural fields; horticulture; and barren land) were combined
              as non-forest cover types.
            </p>

            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/wgb1.png" alt="" />
              ...........(1){" "}
            </p>
            <br />
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/wgb2.png" alt="" />
              ............(2){" "}
            </p>
            <h5>&nbsp;</h5>
            <h5>Identification of Ecological Sensitive Regions(ESR)</h5>
            <p>
              ESR mapping has been carried out by considering the significant
              descriptive variables covering various themes. The study area is
              divided into 5&rsquo;&times; 5&rsquo; equal-area grids (2329)
              corresponding to a grid (5&rsquo;&times;5&rsquo;), covering
              approximately 9&times;9 km<sup>2</sup> of the 1:50000 scale of the
              Survey of India topographic maps. The data of various themes were
              collected through field surveys, review of literature, online
              information portals, and unpublished datasets. A comprehensive
              database of all features ranging from land to the socio-economic
              system has been created.
            </p>
            <p>
              The process of categorizing ESR at disaggregated levels comprised
              of the following steps: (i) considering the significant
              descriptive variables covering various themes which elucidate
              ecological conditions(Liu et al. 2015); (ii) evaluating and
              generating spatial maps based on the environmental sensitiveness
              of each land unit (extent and condition); (iii) developing an
              aggregated weight by linking individual factor weights, which
              assist in dividing/prioritizing the region based on aggregated
              weight into broad classes of sensitivity such as
              &ldquo;exceptionally sensitive, high sensitive, moderately
              sensitive, marginally sensitive, and not sensitive&rdquo; (Leman
              et al. 2016; Ramachandra et al. 2018a, c); (iv) exploring the
              prepared ESR map, offering detailed recommendations for aiding in
              sustainable developmental prospects and enriching the existing
              forest cover (Gadgil et al. 2011; Ramachandra et al. 2020a).The
              preliminary analysis has resulted in a series of weight maps
              pertaining to various themes. The weightage metric score has been
              computed to capture the priorities associated with each theme
              (based on the extent and condition),which assists in combining
              knowledge from a wide array of disciplines (Beinat 1997;
              Termorshuizen and Opdam 2009). The weights are assigned as per
              Equation 3,
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/formula/wgb3.png" alt="" />
              ...........(3)
            </p>
            <p>
              where n is the number of data sets, V<sub>i</sub> is the value
              associated with criterion i, and W<sub>i</sub> is the weight
              associated with that criterion. Each theme is described by a group
              of mapped factors normalized between 10 and2. Grids were assigned
              a value of 10 for high-priority conservation, whereas 2 is for
              lowest priority. The values8, 6, and 4 correspond to high,
              moderate, and low levels of conservation based on the input factor
              values (Ramachandra et al., 2018a). Weights computed for each
              variable are aggregated for each grid. Grids are grouped into four
              categories based on the aggregate score as ESR 1, ESR 2, ESR 3,
              and ESR 4 (ESR 1: aggregated scores &gt; &micro;+2&sigma; (&micro;
              indicates average value and &sigma; indicates the standard
              deviation), ESR 2 (for grids within &micro;+2&sigma; and
              &micro;+&sigma;), ESR 3 (for grids with &micro;+&sigma; and
              &micro;) and ESR 4 (grids with values &lt; &micro;). In
              particular, the weights are based on an individual proxy and
              depend extensively on GIS techniques, which is the most effective
              method.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default SAMPage;
